import type { ReactNode } from 'react';
import type { JSX } from 'react';

import { cn } from '@/lib/utils';

import './status-page.scss';

type StatusPageVariant = 'full' | 'in-main';

type StatusPageProps = {
  title: string;
  description: string;
  icon?: ReactNode;
  actions?: ReactNode;
  variant?: StatusPageVariant;
};

export function StatusPage({
  title,
  description,
  icon,
  actions,
  variant = 'full',
}: StatusPageProps): JSX.Element {
  return (
    <div
      className={cn(
        'status-page',
        variant === 'full' && 'status-page--full',
        variant === 'in-main' && 'status-page--in-main',
      )}
    >
      <div className="status-page__content">
        {icon ? <div className="status-page__icon">{icon}</div> : null}
        <h1 className="status-page__title">{title}</h1>
        <p className="status-page__description">{description}</p>
        {actions ? <div className="status-page__actions">{actions}</div> : null}
      </div>
    </div>
  );
}
